// src/admin/components/ProtectedRoute.js
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = () => {
  // Check if the admin token exists in local storage
  const token = localStorage.getItem('adminToken');

  // If token exists, render the child component (e.g., Dashboard)
  // Outlet component React Router se aata hai aur child route ko render karta hai
  if (token) {
    return <Outlet />;
  }
  
  // If token does not exist, redirect to the login page
  return <Navigate to="/admin/login" />;
};

export default ProtectedRoute;